import { Material, MaterialType } from "@/models/material.model";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject } from "rxjs";

class MaterialsService {
  static materials$ = new BehaviorSubject([]);
  static materials = this.materials$.asObservable();

  static setMaterialObjective(data: any): void {
    this.materials$.next(data);
  }

  materialPlansName(value: string): string {
    if (value === MaterialType.ESSENTIAL) {
      value = GenericsUtils.translateI18n("objects.essential");
    } else if (value === MaterialType.COMPLEMENTARY) {
      value = GenericsUtils.translateI18n("objects.complementary");
    } else {
      value = GenericsUtils.translateI18n("objects.withoutplan");
    }
    return value;
  }

  materialPlansColor(value: string): string {
    if (value === MaterialType.ESSENTIAL) {
      value = "bg-blue-100 text-blue-800";
    } else if (value === MaterialType.COMPLEMENTARY) {
      value = "bg-yellow-100 text-yellow-800";
    } else {
      value = "bg-h-warning-100 text-h-warning-700";
    }
    return value;
  }
}

export { MaterialsService };
